// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/krang.proto

/* eslint-disable */

export const protobufPackage = "models";

/** accessGrantStatus defines an enumeration for the stage an access grant is in. */
export enum AccessGrantStatus {
  STATUS_UNSPECIFIED = 0,
  STATUS_PENDING_APPROVAL = 1,
  STATUS_APPROVED = 2,
  STATUS_DENIED = 3,
  STATUS_EXPIRED = 4,
  STATUS_DELETED = 5,
  STATUS_FAILED = 6,
  UNRECOGNIZED = -1,
}

export function accessGrantStatusFromJSON(object: any): AccessGrantStatus {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return AccessGrantStatus.STATUS_UNSPECIFIED;
    case 1:
    case "STATUS_PENDING_APPROVAL":
      return AccessGrantStatus.STATUS_PENDING_APPROVAL;
    case 2:
    case "STATUS_APPROVED":
      return AccessGrantStatus.STATUS_APPROVED;
    case 3:
    case "STATUS_DENIED":
      return AccessGrantStatus.STATUS_DENIED;
    case 4:
    case "STATUS_EXPIRED":
      return AccessGrantStatus.STATUS_EXPIRED;
    case 5:
    case "STATUS_DELETED":
      return AccessGrantStatus.STATUS_DELETED;
    case 6:
    case "STATUS_FAILED":
      return AccessGrantStatus.STATUS_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessGrantStatus.UNRECOGNIZED;
  }
}

export function accessGrantStatusToJSON(object: AccessGrantStatus): string {
  switch (object) {
    case AccessGrantStatus.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case AccessGrantStatus.STATUS_PENDING_APPROVAL:
      return "STATUS_PENDING_APPROVAL";
    case AccessGrantStatus.STATUS_APPROVED:
      return "STATUS_APPROVED";
    case AccessGrantStatus.STATUS_DENIED:
      return "STATUS_DENIED";
    case AccessGrantStatus.STATUS_EXPIRED:
      return "STATUS_EXPIRED";
    case AccessGrantStatus.STATUS_DELETED:
      return "STATUS_DELETED";
    case AccessGrantStatus.STATUS_FAILED:
      return "STATUS_FAILED";
    case AccessGrantStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** AccessGrantType defines an enumeration for access grant types. */
export enum AccessGrantType {
  GRANT_TYPE_UNSPECIFIED = 0,
  /** GRANT_TYPE_CERT_BASED_SPYGLASS - This grant authorizes the support readwrite user to get access via a signed ssh cert */
  GRANT_TYPE_CERT_BASED_SPYGLASS = 1,
  /** GRANT_TYPE_FISHHOOK - This grant authorizes a support readwrite user to get a fishhook json blob signed by krang */
  GRANT_TYPE_FISHHOOK = 2,
  /** GRANT_TYPE_ONESHOT - This grant authorizes a support readonly user to get access to oneshot command output */
  GRANT_TYPE_ONESHOT = 3,
  /** GRANT_TYPE_RMA - This grant authorizes a support user to perform RMA related actions for a device */
  GRANT_TYPE_RMA = 4,
  UNRECOGNIZED = -1,
}

export function accessGrantTypeFromJSON(object: any): AccessGrantType {
  switch (object) {
    case 0:
    case "GRANT_TYPE_UNSPECIFIED":
      return AccessGrantType.GRANT_TYPE_UNSPECIFIED;
    case 1:
    case "GRANT_TYPE_CERT_BASED_SPYGLASS":
      return AccessGrantType.GRANT_TYPE_CERT_BASED_SPYGLASS;
    case 2:
    case "GRANT_TYPE_FISHHOOK":
      return AccessGrantType.GRANT_TYPE_FISHHOOK;
    case 3:
    case "GRANT_TYPE_ONESHOT":
      return AccessGrantType.GRANT_TYPE_ONESHOT;
    case 4:
    case "GRANT_TYPE_RMA":
      return AccessGrantType.GRANT_TYPE_RMA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessGrantType.UNRECOGNIZED;
  }
}

export function accessGrantTypeToJSON(object: AccessGrantType): string {
  switch (object) {
    case AccessGrantType.GRANT_TYPE_UNSPECIFIED:
      return "GRANT_TYPE_UNSPECIFIED";
    case AccessGrantType.GRANT_TYPE_CERT_BASED_SPYGLASS:
      return "GRANT_TYPE_CERT_BASED_SPYGLASS";
    case AccessGrantType.GRANT_TYPE_FISHHOOK:
      return "GRANT_TYPE_FISHHOOK";
    case AccessGrantType.GRANT_TYPE_ONESHOT:
      return "GRANT_TYPE_ONESHOT";
    case AccessGrantType.GRANT_TYPE_RMA:
      return "GRANT_TYPE_RMA";
    case AccessGrantType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** accessType defines an enumeration for the access type a given user has within the org/fabric scope for support */
export enum AccessType {
  /** ACCESS_TYPE_UNSPECIFIED - Unspecified access type. */
  ACCESS_TYPE_UNSPECIFIED = 0,
  /** ACCESS_TYPE_SPYGLASS - a spyglass access allows users to get direct SSH access to the customer device */
  ACCESS_TYPE_SPYGLASS = 1,
  /** ACCESS_TYPE_ONE_SHOT_COMMAND_RUNS - a one shot access allows users to get the output from running a pre-curated group of commands on the device */
  ACCESS_TYPE_ONE_SHOT_COMMAND_RUNS = 2,
  /** ACCESS_TYPE_DELEGATED_READONLY_USER - a delegated readonly access allows users to get temporarily added as read-only members in a customer organization */
  ACCESS_TYPE_DELEGATED_READONLY_USER = 3,
  /** ACCESS_TYPE_FISHHOOK - a fishhook access allows users to apply fishhook configuration changes to a device */
  ACCESS_TYPE_FISHHOOK = 4,
  /** ACCESS_TYPE_SPYGLASS_APPROVE - a spyglass approve access allows users to approve spyglass requests */
  ACCESS_TYPE_SPYGLASS_APPROVE = 5,
  /** ACCESS_TYPE_FISHHOOK_APPROVE - a fishhook approve access allows users to approve fishhook configuration change requests */
  ACCESS_TYPE_FISHHOOK_APPROVE = 6,
  /** ACCESS_TYPE_CLUSTER_MGMT - a cluster mgmt access gives access to cluster management apis */
  ACCESS_TYPE_CLUSTER_MGMT = 7,
  /** ACCESS_TYPE_SOFTWARE_UPDATE - a software update access gives access to software update apis */
  ACCESS_TYPE_SOFTWARE_UPDATE = 8,
  /** ACCESS_TYPE_RMA - a rma access allows users to perform RMA related actions for a device */
  ACCESS_TYPE_RMA = 9,
  /** ACCESS_TYPE_RMA_APPROVE - a rma approve access allows users to approve RMA requests for a device */
  ACCESS_TYPE_RMA_APPROVE = 10,
  UNRECOGNIZED = -1,
}

export function accessTypeFromJSON(object: any): AccessType {
  switch (object) {
    case 0:
    case "ACCESS_TYPE_UNSPECIFIED":
      return AccessType.ACCESS_TYPE_UNSPECIFIED;
    case 1:
    case "ACCESS_TYPE_SPYGLASS":
      return AccessType.ACCESS_TYPE_SPYGLASS;
    case 2:
    case "ACCESS_TYPE_ONE_SHOT_COMMAND_RUNS":
      return AccessType.ACCESS_TYPE_ONE_SHOT_COMMAND_RUNS;
    case 3:
    case "ACCESS_TYPE_DELEGATED_READONLY_USER":
      return AccessType.ACCESS_TYPE_DELEGATED_READONLY_USER;
    case 4:
    case "ACCESS_TYPE_FISHHOOK":
      return AccessType.ACCESS_TYPE_FISHHOOK;
    case 5:
    case "ACCESS_TYPE_SPYGLASS_APPROVE":
      return AccessType.ACCESS_TYPE_SPYGLASS_APPROVE;
    case 6:
    case "ACCESS_TYPE_FISHHOOK_APPROVE":
      return AccessType.ACCESS_TYPE_FISHHOOK_APPROVE;
    case 7:
    case "ACCESS_TYPE_CLUSTER_MGMT":
      return AccessType.ACCESS_TYPE_CLUSTER_MGMT;
    case 8:
    case "ACCESS_TYPE_SOFTWARE_UPDATE":
      return AccessType.ACCESS_TYPE_SOFTWARE_UPDATE;
    case 9:
    case "ACCESS_TYPE_RMA":
      return AccessType.ACCESS_TYPE_RMA;
    case 10:
    case "ACCESS_TYPE_RMA_APPROVE":
      return AccessType.ACCESS_TYPE_RMA_APPROVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AccessType.UNRECOGNIZED;
  }
}

export function accessTypeToJSON(object: AccessType): string {
  switch (object) {
    case AccessType.ACCESS_TYPE_UNSPECIFIED:
      return "ACCESS_TYPE_UNSPECIFIED";
    case AccessType.ACCESS_TYPE_SPYGLASS:
      return "ACCESS_TYPE_SPYGLASS";
    case AccessType.ACCESS_TYPE_ONE_SHOT_COMMAND_RUNS:
      return "ACCESS_TYPE_ONE_SHOT_COMMAND_RUNS";
    case AccessType.ACCESS_TYPE_DELEGATED_READONLY_USER:
      return "ACCESS_TYPE_DELEGATED_READONLY_USER";
    case AccessType.ACCESS_TYPE_FISHHOOK:
      return "ACCESS_TYPE_FISHHOOK";
    case AccessType.ACCESS_TYPE_SPYGLASS_APPROVE:
      return "ACCESS_TYPE_SPYGLASS_APPROVE";
    case AccessType.ACCESS_TYPE_FISHHOOK_APPROVE:
      return "ACCESS_TYPE_FISHHOOK_APPROVE";
    case AccessType.ACCESS_TYPE_CLUSTER_MGMT:
      return "ACCESS_TYPE_CLUSTER_MGMT";
    case AccessType.ACCESS_TYPE_SOFTWARE_UPDATE:
      return "ACCESS_TYPE_SOFTWARE_UPDATE";
    case AccessType.ACCESS_TYPE_RMA:
      return "ACCESS_TYPE_RMA";
    case AccessType.ACCESS_TYPE_RMA_APPROVE:
      return "ACCESS_TYPE_RMA_APPROVE";
    case AccessType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ApiType defines an API route as being either a GRPC or REST endpoint. */
export enum ApiType {
  API_TYPE_UNSPECIFIED = 0,
  API_TYPE_GRPC = 1,
  API_TYPE_REST = 2,
  UNRECOGNIZED = -1,
}

export function apiTypeFromJSON(object: any): ApiType {
  switch (object) {
    case 0:
    case "API_TYPE_UNSPECIFIED":
      return ApiType.API_TYPE_UNSPECIFIED;
    case 1:
    case "API_TYPE_GRPC":
      return ApiType.API_TYPE_GRPC;
    case 2:
    case "API_TYPE_REST":
      return ApiType.API_TYPE_REST;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ApiType.UNRECOGNIZED;
  }
}

export function apiTypeToJSON(object: ApiType): string {
  switch (object) {
    case ApiType.API_TYPE_UNSPECIFIED:
      return "API_TYPE_UNSPECIFIED";
    case ApiType.API_TYPE_GRPC:
      return "API_TYPE_GRPC";
    case ApiType.API_TYPE_REST:
      return "API_TYPE_REST";
    case ApiType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** authorization_validation_error_type defines an enumeration of error types for */
export enum AuthorizationValidationErrorType {
  /** VALIDATION_ERR_UNSPECIFIED - Unspecified validation error. */
  VALIDATION_ERR_UNSPECIFIED = 0,
  /** VALIDATION_ERR_NONE - authorized user entries are validated */
  VALIDATION_ERR_NONE = 1,
  /** VALIDATION_ERR_NIL_ORGID - authorized user update is rejected since it does not have org id */
  VALIDATION_ERR_NIL_ORGID = 2,
  /** VALIDATION_ERR_SCOPE_TOO_BROAD_FOR_DRO - authorized user update is rejected since it has delegated read access type but has a special org id */
  VALIDATION_ERR_SCOPE_TOO_BROAD_FOR_DRO = 3,
  /** VALIDATION_ERR_NON_NIL_FABID_FOR_DRO - authorized user update is rejected since it has delegated read access type but has a fabric id */
  VALIDATION_ERR_NON_NIL_FABID_FOR_DRO = 4,
  /**
   * VALIDATION_ERR_CONFLICTING_FABRIC_SCOPE - authorized user update is rejected since it has same access type same org id but has a fabric id conflicting
   * with the special fabric id
   */
  VALIDATION_ERR_CONFLICTING_FABRIC_SCOPE = 5,
  /** VALIDATION_ERR_INVALID_FILENAME_PATTERN - authorized user update is rejected since the filename uploaded by support team does not follow valid pattern */
  VALIDATION_ERR_INVALID_FILENAME_PATTERN = 6,
  /** VALIDATION_ERR_FILE_MISSING_MARKERS - authorized user update is rejected since the support user file is missing starting or ending markers */
  VALIDATION_ERR_FILE_MISSING_MARKERS = 7,
  /** VALIDATION_ERR_INVALID_ENTRY_FIELD - authorized user update is rejected since one or more entries have invalid fields */
  VALIDATION_ERR_INVALID_ENTRY_FIELD = 8,
  /** VALIDATION_ERR_INVALID_ACCESS_TYPE - authorized user update is rejected since one or more entries have invalid access type */
  VALIDATION_ERR_INVALID_ACCESS_TYPE = 9,
  UNRECOGNIZED = -1,
}

export function authorizationValidationErrorTypeFromJSON(object: any): AuthorizationValidationErrorType {
  switch (object) {
    case 0:
    case "VALIDATION_ERR_UNSPECIFIED":
      return AuthorizationValidationErrorType.VALIDATION_ERR_UNSPECIFIED;
    case 1:
    case "VALIDATION_ERR_NONE":
      return AuthorizationValidationErrorType.VALIDATION_ERR_NONE;
    case 2:
    case "VALIDATION_ERR_NIL_ORGID":
      return AuthorizationValidationErrorType.VALIDATION_ERR_NIL_ORGID;
    case 3:
    case "VALIDATION_ERR_SCOPE_TOO_BROAD_FOR_DRO":
      return AuthorizationValidationErrorType.VALIDATION_ERR_SCOPE_TOO_BROAD_FOR_DRO;
    case 4:
    case "VALIDATION_ERR_NON_NIL_FABID_FOR_DRO":
      return AuthorizationValidationErrorType.VALIDATION_ERR_NON_NIL_FABID_FOR_DRO;
    case 5:
    case "VALIDATION_ERR_CONFLICTING_FABRIC_SCOPE":
      return AuthorizationValidationErrorType.VALIDATION_ERR_CONFLICTING_FABRIC_SCOPE;
    case 6:
    case "VALIDATION_ERR_INVALID_FILENAME_PATTERN":
      return AuthorizationValidationErrorType.VALIDATION_ERR_INVALID_FILENAME_PATTERN;
    case 7:
    case "VALIDATION_ERR_FILE_MISSING_MARKERS":
      return AuthorizationValidationErrorType.VALIDATION_ERR_FILE_MISSING_MARKERS;
    case 8:
    case "VALIDATION_ERR_INVALID_ENTRY_FIELD":
      return AuthorizationValidationErrorType.VALIDATION_ERR_INVALID_ENTRY_FIELD;
    case 9:
    case "VALIDATION_ERR_INVALID_ACCESS_TYPE":
      return AuthorizationValidationErrorType.VALIDATION_ERR_INVALID_ACCESS_TYPE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AuthorizationValidationErrorType.UNRECOGNIZED;
  }
}

export function authorizationValidationErrorTypeToJSON(object: AuthorizationValidationErrorType): string {
  switch (object) {
    case AuthorizationValidationErrorType.VALIDATION_ERR_UNSPECIFIED:
      return "VALIDATION_ERR_UNSPECIFIED";
    case AuthorizationValidationErrorType.VALIDATION_ERR_NONE:
      return "VALIDATION_ERR_NONE";
    case AuthorizationValidationErrorType.VALIDATION_ERR_NIL_ORGID:
      return "VALIDATION_ERR_NIL_ORGID";
    case AuthorizationValidationErrorType.VALIDATION_ERR_SCOPE_TOO_BROAD_FOR_DRO:
      return "VALIDATION_ERR_SCOPE_TOO_BROAD_FOR_DRO";
    case AuthorizationValidationErrorType.VALIDATION_ERR_NON_NIL_FABID_FOR_DRO:
      return "VALIDATION_ERR_NON_NIL_FABID_FOR_DRO";
    case AuthorizationValidationErrorType.VALIDATION_ERR_CONFLICTING_FABRIC_SCOPE:
      return "VALIDATION_ERR_CONFLICTING_FABRIC_SCOPE";
    case AuthorizationValidationErrorType.VALIDATION_ERR_INVALID_FILENAME_PATTERN:
      return "VALIDATION_ERR_INVALID_FILENAME_PATTERN";
    case AuthorizationValidationErrorType.VALIDATION_ERR_FILE_MISSING_MARKERS:
      return "VALIDATION_ERR_FILE_MISSING_MARKERS";
    case AuthorizationValidationErrorType.VALIDATION_ERR_INVALID_ENTRY_FIELD:
      return "VALIDATION_ERR_INVALID_ENTRY_FIELD";
    case AuthorizationValidationErrorType.VALIDATION_ERR_INVALID_ACCESS_TYPE:
      return "VALIDATION_ERR_INVALID_ACCESS_TYPE";
    case AuthorizationValidationErrorType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** CellAvailabilityType defines an enumeration for the availability status of a cell */
export enum CellAvailabilityType {
  CELL_AVAILABILITY_UNSPECIFIED = 0,
  CELL_AVAILABILITY_ACTIVE = 1,
  CELL_AVAILABILITY_STANDBY = 2,
  CELL_AVAILABILITY_TO_ACTIVE = 3,
  UNRECOGNIZED = -1,
}

export function cellAvailabilityTypeFromJSON(object: any): CellAvailabilityType {
  switch (object) {
    case 0:
    case "CELL_AVAILABILITY_UNSPECIFIED":
      return CellAvailabilityType.CELL_AVAILABILITY_UNSPECIFIED;
    case 1:
    case "CELL_AVAILABILITY_ACTIVE":
      return CellAvailabilityType.CELL_AVAILABILITY_ACTIVE;
    case 2:
    case "CELL_AVAILABILITY_STANDBY":
      return CellAvailabilityType.CELL_AVAILABILITY_STANDBY;
    case 3:
    case "CELL_AVAILABILITY_TO_ACTIVE":
      return CellAvailabilityType.CELL_AVAILABILITY_TO_ACTIVE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CellAvailabilityType.UNRECOGNIZED;
  }
}

export function cellAvailabilityTypeToJSON(object: CellAvailabilityType): string {
  switch (object) {
    case CellAvailabilityType.CELL_AVAILABILITY_UNSPECIFIED:
      return "CELL_AVAILABILITY_UNSPECIFIED";
    case CellAvailabilityType.CELL_AVAILABILITY_ACTIVE:
      return "CELL_AVAILABILITY_ACTIVE";
    case CellAvailabilityType.CELL_AVAILABILITY_STANDBY:
      return "CELL_AVAILABILITY_STANDBY";
    case CellAvailabilityType.CELL_AVAILABILITY_TO_ACTIVE:
      return "CELL_AVAILABILITY_TO_ACTIVE";
    case CellAvailabilityType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ClaimWorkQueueStateType defines an enumeration for the type of state that a claim job current at */
export enum ClaimWorkQueueStateType {
  CLAIM_WORK_QUEUE_STATE_UNSPECIFIED = 0,
  CLAIM_WORK_QUEUE_STATE_CLAIM = 1,
  CLAIM_WORK_QUEUE_STATE_CLEAN = 2,
  CLAIM_WORK_QUEUE_STATE_FINISHED = 3,
  CLAIM_WORK_QUEUE_STATE_REMOVE = 4,
  CLAIM_WORK_QUEUE_STATE_ADD = 5,
  UNRECOGNIZED = -1,
}

export function claimWorkQueueStateTypeFromJSON(object: any): ClaimWorkQueueStateType {
  switch (object) {
    case 0:
    case "CLAIM_WORK_QUEUE_STATE_UNSPECIFIED":
      return ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_UNSPECIFIED;
    case 1:
    case "CLAIM_WORK_QUEUE_STATE_CLAIM":
      return ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_CLAIM;
    case 2:
    case "CLAIM_WORK_QUEUE_STATE_CLEAN":
      return ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_CLEAN;
    case 3:
    case "CLAIM_WORK_QUEUE_STATE_FINISHED":
      return ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_FINISHED;
    case 4:
    case "CLAIM_WORK_QUEUE_STATE_REMOVE":
      return ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_REMOVE;
    case 5:
    case "CLAIM_WORK_QUEUE_STATE_ADD":
      return ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_ADD;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ClaimWorkQueueStateType.UNRECOGNIZED;
  }
}

export function claimWorkQueueStateTypeToJSON(object: ClaimWorkQueueStateType): string {
  switch (object) {
    case ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_UNSPECIFIED:
      return "CLAIM_WORK_QUEUE_STATE_UNSPECIFIED";
    case ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_CLAIM:
      return "CLAIM_WORK_QUEUE_STATE_CLAIM";
    case ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_CLEAN:
      return "CLAIM_WORK_QUEUE_STATE_CLEAN";
    case ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_FINISHED:
      return "CLAIM_WORK_QUEUE_STATE_FINISHED";
    case ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_REMOVE:
      return "CLAIM_WORK_QUEUE_STATE_REMOVE";
    case ClaimWorkQueueStateType.CLAIM_WORK_QUEUE_STATE_ADD:
      return "CLAIM_WORK_QUEUE_STATE_ADD";
    case ClaimWorkQueueStateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** endpoint_data_scope specifies if the export endpoint is internal or tac */
export enum EndpointDataScope {
  /** ENDPOINT_SCOPE_UNSPECIFIED - ENDPOINT_SCOPE_UNSPECIFIED specifies an unspecified endpoint scope. */
  ENDPOINT_SCOPE_UNSPECIFIED = 0,
  /** ENDPOINT_SCOPE_INTERNAL - ENDPOINT_SCOPE_INTERNAL specifies the internal dev endpoint scope. */
  ENDPOINT_SCOPE_INTERNAL = 1,
  /** ENDPOINT_SCOPE_TAC - ENDPOINT_SCOPE_TAC specifies the tac users' endpoint scope. */
  ENDPOINT_SCOPE_TAC = 2,
  UNRECOGNIZED = -1,
}

export function endpointDataScopeFromJSON(object: any): EndpointDataScope {
  switch (object) {
    case 0:
    case "ENDPOINT_SCOPE_UNSPECIFIED":
      return EndpointDataScope.ENDPOINT_SCOPE_UNSPECIFIED;
    case 1:
    case "ENDPOINT_SCOPE_INTERNAL":
      return EndpointDataScope.ENDPOINT_SCOPE_INTERNAL;
    case 2:
    case "ENDPOINT_SCOPE_TAC":
      return EndpointDataScope.ENDPOINT_SCOPE_TAC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EndpointDataScope.UNRECOGNIZED;
  }
}

export function endpointDataScopeToJSON(object: EndpointDataScope): string {
  switch (object) {
    case EndpointDataScope.ENDPOINT_SCOPE_UNSPECIFIED:
      return "ENDPOINT_SCOPE_UNSPECIFIED";
    case EndpointDataScope.ENDPOINT_SCOPE_INTERNAL:
      return "ENDPOINT_SCOPE_INTERNAL";
    case EndpointDataScope.ENDPOINT_SCOPE_TAC:
      return "ENDPOINT_SCOPE_TAC";
    case EndpointDataScope.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** endpoint_data_type defines a data type for the endpoint. */
export enum EndpointDataType {
  /** ENDPOINT_TYPE_UNSPECIFIED - ENDPOINT_TYPE_UNSPECIFIED specifies an unspecified endpoint type. */
  ENDPOINT_TYPE_UNSPECIFIED = 0,
  /** ENDPOINT_TYPE_S3 - ENDPOINT_TYPE_S3 specifies the endpoint type to be s3. */
  ENDPOINT_TYPE_S3 = 1,
  UNRECOGNIZED = -1,
}

export function endpointDataTypeFromJSON(object: any): EndpointDataType {
  switch (object) {
    case 0:
    case "ENDPOINT_TYPE_UNSPECIFIED":
      return EndpointDataType.ENDPOINT_TYPE_UNSPECIFIED;
    case 1:
    case "ENDPOINT_TYPE_S3":
      return EndpointDataType.ENDPOINT_TYPE_S3;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EndpointDataType.UNRECOGNIZED;
  }
}

export function endpointDataTypeToJSON(object: EndpointDataType): string {
  switch (object) {
    case EndpointDataType.ENDPOINT_TYPE_UNSPECIFIED:
      return "ENDPOINT_TYPE_UNSPECIFIED";
    case EndpointDataType.ENDPOINT_TYPE_S3:
      return "ENDPOINT_TYPE_S3";
    case EndpointDataType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** InventoryUpdateStatus defines an enumeration for the status of a Inventory update */
export enum InventoryUploadStatusType {
  INVENTORY_UPLOAD_STATUS_UNSPECIFIED = 0,
  INVENTORY_UPLOAD_COMPLETED = 1,
  INVENTORY_UPLOAD_FAILED_TO_COMPLETE = 2,
  UNRECOGNIZED = -1,
}

export function inventoryUploadStatusTypeFromJSON(object: any): InventoryUploadStatusType {
  switch (object) {
    case 0:
    case "INVENTORY_UPLOAD_STATUS_UNSPECIFIED":
      return InventoryUploadStatusType.INVENTORY_UPLOAD_STATUS_UNSPECIFIED;
    case 1:
    case "INVENTORY_UPLOAD_COMPLETED":
      return InventoryUploadStatusType.INVENTORY_UPLOAD_COMPLETED;
    case 2:
    case "INVENTORY_UPLOAD_FAILED_TO_COMPLETE":
      return InventoryUploadStatusType.INVENTORY_UPLOAD_FAILED_TO_COMPLETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InventoryUploadStatusType.UNRECOGNIZED;
  }
}

export function inventoryUploadStatusTypeToJSON(object: InventoryUploadStatusType): string {
  switch (object) {
    case InventoryUploadStatusType.INVENTORY_UPLOAD_STATUS_UNSPECIFIED:
      return "INVENTORY_UPLOAD_STATUS_UNSPECIFIED";
    case InventoryUploadStatusType.INVENTORY_UPLOAD_COMPLETED:
      return "INVENTORY_UPLOAD_COMPLETED";
    case InventoryUploadStatusType.INVENTORY_UPLOAD_FAILED_TO_COMPLETE:
      return "INVENTORY_UPLOAD_FAILED_TO_COMPLETE";
    case InventoryUploadStatusType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** krangRole defines an enumeration for the role a given user has within the Krang UI */
export enum KrangRole {
  /** KRANG_ROLE_UNSPECIFIED - Unspecified Krang role. */
  KRANG_ROLE_UNSPECIFIED = 0,
  /**
   * KRANG_ROLE_ADMIN - a krang admin is a global Tortuga admin (ops) that has the privileges to push code
   * add authorized users, approve grants and other high privilege activities
   */
  KRANG_ROLE_ADMIN = 1,
  /**
   * KRANG_ROLE_SUPPORT_ADMIN - a krang support admin cannot push code, but they can add authorized support users
   * and approve access grant requests for switches
   */
  KRANG_ROLE_SUPPORT_ADMIN = 2,
  /** KRANG_ROLE_INTERNAL_USER - a krang internal user is from the tortuga engineering and some marketing folks */
  KRANG_ROLE_INTERNAL_USER = 3,
  /** KRANG_ROLE_SUPPORT_USER - a krang support user is added from tac support */
  KRANG_ROLE_SUPPORT_USER = 4,
  UNRECOGNIZED = -1,
}

export function krangRoleFromJSON(object: any): KrangRole {
  switch (object) {
    case 0:
    case "KRANG_ROLE_UNSPECIFIED":
      return KrangRole.KRANG_ROLE_UNSPECIFIED;
    case 1:
    case "KRANG_ROLE_ADMIN":
      return KrangRole.KRANG_ROLE_ADMIN;
    case 2:
    case "KRANG_ROLE_SUPPORT_ADMIN":
      return KrangRole.KRANG_ROLE_SUPPORT_ADMIN;
    case 3:
    case "KRANG_ROLE_INTERNAL_USER":
      return KrangRole.KRANG_ROLE_INTERNAL_USER;
    case 4:
    case "KRANG_ROLE_SUPPORT_USER":
      return KrangRole.KRANG_ROLE_SUPPORT_USER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return KrangRole.UNRECOGNIZED;
  }
}

export function krangRoleToJSON(object: KrangRole): string {
  switch (object) {
    case KrangRole.KRANG_ROLE_UNSPECIFIED:
      return "KRANG_ROLE_UNSPECIFIED";
    case KrangRole.KRANG_ROLE_ADMIN:
      return "KRANG_ROLE_ADMIN";
    case KrangRole.KRANG_ROLE_SUPPORT_ADMIN:
      return "KRANG_ROLE_SUPPORT_ADMIN";
    case KrangRole.KRANG_ROLE_INTERNAL_USER:
      return "KRANG_ROLE_INTERNAL_USER";
    case KrangRole.KRANG_ROLE_SUPPORT_USER:
      return "KRANG_ROLE_SUPPORT_USER";
    case KrangRole.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** oneshotSessionStatus defines an enumeration for the status of a oneshot session */
export enum OneshotSessionStatus {
  ONESHOT_SESSION_STATUS_UNSPECIFIED = 0,
  ONESHOT_SESSION_STATUS_CREATED = 1,
  ONESHOT_SESSION_STATUS_IN_PROGRESS = 2,
  ONESHOT_SESSION_STATUS_COMPLETED = 3,
  ONESHOT_SESSION_STATUS_FAILED = 4,
  ONESHOT_SESSION_STATUS_DELETED = 5,
  UNRECOGNIZED = -1,
}

export function oneshotSessionStatusFromJSON(object: any): OneshotSessionStatus {
  switch (object) {
    case 0:
    case "ONESHOT_SESSION_STATUS_UNSPECIFIED":
      return OneshotSessionStatus.ONESHOT_SESSION_STATUS_UNSPECIFIED;
    case 1:
    case "ONESHOT_SESSION_STATUS_CREATED":
      return OneshotSessionStatus.ONESHOT_SESSION_STATUS_CREATED;
    case 2:
    case "ONESHOT_SESSION_STATUS_IN_PROGRESS":
      return OneshotSessionStatus.ONESHOT_SESSION_STATUS_IN_PROGRESS;
    case 3:
    case "ONESHOT_SESSION_STATUS_COMPLETED":
      return OneshotSessionStatus.ONESHOT_SESSION_STATUS_COMPLETED;
    case 4:
    case "ONESHOT_SESSION_STATUS_FAILED":
      return OneshotSessionStatus.ONESHOT_SESSION_STATUS_FAILED;
    case 5:
    case "ONESHOT_SESSION_STATUS_DELETED":
      return OneshotSessionStatus.ONESHOT_SESSION_STATUS_DELETED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OneshotSessionStatus.UNRECOGNIZED;
  }
}

export function oneshotSessionStatusToJSON(object: OneshotSessionStatus): string {
  switch (object) {
    case OneshotSessionStatus.ONESHOT_SESSION_STATUS_UNSPECIFIED:
      return "ONESHOT_SESSION_STATUS_UNSPECIFIED";
    case OneshotSessionStatus.ONESHOT_SESSION_STATUS_CREATED:
      return "ONESHOT_SESSION_STATUS_CREATED";
    case OneshotSessionStatus.ONESHOT_SESSION_STATUS_IN_PROGRESS:
      return "ONESHOT_SESSION_STATUS_IN_PROGRESS";
    case OneshotSessionStatus.ONESHOT_SESSION_STATUS_COMPLETED:
      return "ONESHOT_SESSION_STATUS_COMPLETED";
    case OneshotSessionStatus.ONESHOT_SESSION_STATUS_FAILED:
      return "ONESHOT_SESSION_STATUS_FAILED";
    case OneshotSessionStatus.ONESHOT_SESSION_STATUS_DELETED:
      return "ONESHOT_SESSION_STATUS_DELETED";
    case OneshotSessionStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** RmaStateType defines an enumeration for the type of state that a RMA process current at */
export enum RmaStateType {
  RMA_STATE_UNSPECIFIED = 0,
  RMA_STATE_UNBIND = 1,
  RMA_STATE_UNCLAIM = 2,
  RMA_STATE_FINISHED = 3,
  UNRECOGNIZED = -1,
}

export function rmaStateTypeFromJSON(object: any): RmaStateType {
  switch (object) {
    case 0:
    case "RMA_STATE_UNSPECIFIED":
      return RmaStateType.RMA_STATE_UNSPECIFIED;
    case 1:
    case "RMA_STATE_UNBIND":
      return RmaStateType.RMA_STATE_UNBIND;
    case 2:
    case "RMA_STATE_UNCLAIM":
      return RmaStateType.RMA_STATE_UNCLAIM;
    case 3:
    case "RMA_STATE_FINISHED":
      return RmaStateType.RMA_STATE_FINISHED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RmaStateType.UNRECOGNIZED;
  }
}

export function rmaStateTypeToJSON(object: RmaStateType): string {
  switch (object) {
    case RmaStateType.RMA_STATE_UNSPECIFIED:
      return "RMA_STATE_UNSPECIFIED";
    case RmaStateType.RMA_STATE_UNBIND:
      return "RMA_STATE_UNBIND";
    case RmaStateType.RMA_STATE_UNCLAIM:
      return "RMA_STATE_UNCLAIM";
    case RmaStateType.RMA_STATE_FINISHED:
      return "RMA_STATE_FINISHED";
    case RmaStateType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ScanStatusType defines an enumeration for scan status types. */
export enum ScanStatusType {
  SCAN_STATUS_UNSPECIFIED = 0,
  SCAN_STATUS_SUCCESS = 1,
  SCAN_STATUS_DOWNLOAD_FAILURE = 2,
  SCAN_STATUS_VALIDATION_FAILURE = 3,
  SCAN_STATUS_UPDATE_FAILURE = 4,
  SCAN_STATUS_SYNC_FAILURE = 5,
  SCAN_STATUS_PARTIAL_SUCCESS = 6,
  UNRECOGNIZED = -1,
}

export function scanStatusTypeFromJSON(object: any): ScanStatusType {
  switch (object) {
    case 0:
    case "SCAN_STATUS_UNSPECIFIED":
      return ScanStatusType.SCAN_STATUS_UNSPECIFIED;
    case 1:
    case "SCAN_STATUS_SUCCESS":
      return ScanStatusType.SCAN_STATUS_SUCCESS;
    case 2:
    case "SCAN_STATUS_DOWNLOAD_FAILURE":
      return ScanStatusType.SCAN_STATUS_DOWNLOAD_FAILURE;
    case 3:
    case "SCAN_STATUS_VALIDATION_FAILURE":
      return ScanStatusType.SCAN_STATUS_VALIDATION_FAILURE;
    case 4:
    case "SCAN_STATUS_UPDATE_FAILURE":
      return ScanStatusType.SCAN_STATUS_UPDATE_FAILURE;
    case 5:
    case "SCAN_STATUS_SYNC_FAILURE":
      return ScanStatusType.SCAN_STATUS_SYNC_FAILURE;
    case 6:
    case "SCAN_STATUS_PARTIAL_SUCCESS":
      return ScanStatusType.SCAN_STATUS_PARTIAL_SUCCESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScanStatusType.UNRECOGNIZED;
  }
}

export function scanStatusTypeToJSON(object: ScanStatusType): string {
  switch (object) {
    case ScanStatusType.SCAN_STATUS_UNSPECIFIED:
      return "SCAN_STATUS_UNSPECIFIED";
    case ScanStatusType.SCAN_STATUS_SUCCESS:
      return "SCAN_STATUS_SUCCESS";
    case ScanStatusType.SCAN_STATUS_DOWNLOAD_FAILURE:
      return "SCAN_STATUS_DOWNLOAD_FAILURE";
    case ScanStatusType.SCAN_STATUS_VALIDATION_FAILURE:
      return "SCAN_STATUS_VALIDATION_FAILURE";
    case ScanStatusType.SCAN_STATUS_UPDATE_FAILURE:
      return "SCAN_STATUS_UPDATE_FAILURE";
    case ScanStatusType.SCAN_STATUS_SYNC_FAILURE:
      return "SCAN_STATUS_SYNC_FAILURE";
    case ScanStatusType.SCAN_STATUS_PARTIAL_SUCCESS:
      return "SCAN_STATUS_PARTIAL_SUCCESS";
    case ScanStatusType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** ActionType defines an enumeration for the type of action that can be taken on a software update request */
export enum SoftwareUpdateActionType {
  SOFTWARE_UPDATE_ACTION_UNSPECIFIED = 0,
  SOFTWARE_UPDATE_ACTION_START = 1,
  SOFTWARE_UPDATE_ACTION_STOP = 2,
  UNRECOGNIZED = -1,
}

export function softwareUpdateActionTypeFromJSON(object: any): SoftwareUpdateActionType {
  switch (object) {
    case 0:
    case "SOFTWARE_UPDATE_ACTION_UNSPECIFIED":
      return SoftwareUpdateActionType.SOFTWARE_UPDATE_ACTION_UNSPECIFIED;
    case 1:
    case "SOFTWARE_UPDATE_ACTION_START":
      return SoftwareUpdateActionType.SOFTWARE_UPDATE_ACTION_START;
    case 2:
    case "SOFTWARE_UPDATE_ACTION_STOP":
      return SoftwareUpdateActionType.SOFTWARE_UPDATE_ACTION_STOP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SoftwareUpdateActionType.UNRECOGNIZED;
  }
}

export function softwareUpdateActionTypeToJSON(object: SoftwareUpdateActionType): string {
  switch (object) {
    case SoftwareUpdateActionType.SOFTWARE_UPDATE_ACTION_UNSPECIFIED:
      return "SOFTWARE_UPDATE_ACTION_UNSPECIFIED";
    case SoftwareUpdateActionType.SOFTWARE_UPDATE_ACTION_START:
      return "SOFTWARE_UPDATE_ACTION_START";
    case SoftwareUpdateActionType.SOFTWARE_UPDATE_ACTION_STOP:
      return "SOFTWARE_UPDATE_ACTION_STOP";
    case SoftwareUpdateActionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** SoftwareUpdateStatus defines an enumeration for the status of a software update request */
export enum SoftwareUpdateStatusType {
  SOFTWARE_UPDATE_STATUS_UNSPECIFIED = 0,
  SOFTWARE_UPDATE_STATUS_CREATED = 1,
  SOFTWARE_UPDATE_STATUS_PENDING = 2,
  SOFTWARE_UPDATE_STATUS_IN_PROGRESS = 3,
  SOFTWARE_UPDATE_STATUS_COMPLETED = 4,
  SOFTWARE_UPDATE_STATUS_FAILED = 5,
  SOFTWARE_UPDATE_STATUS_CANCELED = 6,
  SOFTWARE_UPDATE_STATUS_SKIPPED = 7,
  UNRECOGNIZED = -1,
}

export function softwareUpdateStatusTypeFromJSON(object: any): SoftwareUpdateStatusType {
  switch (object) {
    case 0:
    case "SOFTWARE_UPDATE_STATUS_UNSPECIFIED":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_UNSPECIFIED;
    case 1:
    case "SOFTWARE_UPDATE_STATUS_CREATED":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_CREATED;
    case 2:
    case "SOFTWARE_UPDATE_STATUS_PENDING":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_PENDING;
    case 3:
    case "SOFTWARE_UPDATE_STATUS_IN_PROGRESS":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_IN_PROGRESS;
    case 4:
    case "SOFTWARE_UPDATE_STATUS_COMPLETED":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_COMPLETED;
    case 5:
    case "SOFTWARE_UPDATE_STATUS_FAILED":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_FAILED;
    case 6:
    case "SOFTWARE_UPDATE_STATUS_CANCELED":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_CANCELED;
    case 7:
    case "SOFTWARE_UPDATE_STATUS_SKIPPED":
      return SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_SKIPPED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SoftwareUpdateStatusType.UNRECOGNIZED;
  }
}

export function softwareUpdateStatusTypeToJSON(object: SoftwareUpdateStatusType): string {
  switch (object) {
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_UNSPECIFIED:
      return "SOFTWARE_UPDATE_STATUS_UNSPECIFIED";
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_CREATED:
      return "SOFTWARE_UPDATE_STATUS_CREATED";
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_PENDING:
      return "SOFTWARE_UPDATE_STATUS_PENDING";
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_IN_PROGRESS:
      return "SOFTWARE_UPDATE_STATUS_IN_PROGRESS";
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_COMPLETED:
      return "SOFTWARE_UPDATE_STATUS_COMPLETED";
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_FAILED:
      return "SOFTWARE_UPDATE_STATUS_FAILED";
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_CANCELED:
      return "SOFTWARE_UPDATE_STATUS_CANCELED";
    case SoftwareUpdateStatusType.SOFTWARE_UPDATE_STATUS_SKIPPED:
      return "SOFTWARE_UPDATE_STATUS_SKIPPED";
    case SoftwareUpdateStatusType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
